import { Suspense } from 'react';
import Blogs from '../src/components/class_landing_page/organisms/Blogs';
import Shop from '../src/components/class_landing_page/organisms/Shop';
import CustomHead from '../src/components/common/CustomHead';
import Footer from '../src/components/common/Footer';
import LoadingPage from '../src/components/common/LoadingPage';
import { FirstView } from '../src/components/root/FirstView';
import { Notification } from '../src/components/root/Notification';
import { businessSchema, organizationSchema, websiteSchema } from '../src/constants/BusinessSchema';
import styles from './index.module.scss';

const Top = () => (
  <Suspense fallback={<LoadingPage />}>
    <CustomHead
      title="みらいキッズモンテプリスクール モンテッソーリ保育園・幼児教室"
      description="モンテ歴20年以上の講師が代表を努める神戸のモンテッソーリ保育園・教室です"
      ogpType="website"
      twitterCardType="summary_large_image"
      thumbnailImageUrl="/img/image-montessori-tool-1.webp"
      canonicalUrl="/"
    >
      <script
        id="ld-json-website"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteSchema) }}
      />
      <script
        id="ld-json-preschool"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(businessSchema) }}
      />
      <script
        id="ld-json-organization"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationSchema) }}
      />
    </CustomHead>
    <div>
      <FirstView />
      <Notification />
      <Blogs />
      <Shop />
      <div className={styles['pc-only']}>
        <Footer variant="pc" />
      </div>
      <div className={styles['sp-only']}>
        <Footer variant="mobile" />
      </div>
    </div>
  </Suspense>
);

export default Top;
